/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Switch component styles
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { createStyles } from '@material-ui/core';

import { colors } from '../../../theme';

const SwitchStyles = createStyles({
    root: {
        width: 48,
        height: 28,
        padding: 0,
        margin: 0,
    },
    switchBase: {
        'margin': 1,
        'padding': 0,
        'border': `1px solid ${colors.borderColorLight}`,
        'boxShadow': '0px 3px 3px rgba(0, 0, 0, 0.05), 0px 3px 1px rgba(0, 0, 0, 0.05)',
        // Off State
        // common
        'color': colors.backgroundColorWhite,
        '& + $track': {
            backgroundColor: colors.backgroundColorWhite,
            opacity: 1,
            border: '2px solid rgba(0, 0, 0, 0.05)',
        },
        // hover
        '&:hover': {
            'color': colors.backgroundColorWhite,
            '& + $track': {
                backgroundColor: colors.backgroundColorHoverNormal,
                opacity: 1,
                border: 'none',
            },
        },
        // disabled
        '&$disabled': {
            'color': colors.backgroundColorWhite,
            '& + $track': {
                backgroundColor: colors.backgroundColorHoverNormal,
                opacity: 1,
                border: 'none',
            },
        },
        // On state
        '&$checked': {
            // common
            'color': colors.backgroundColorWhite,
            '& + $track': {
                backgroundColor: colors.backgroundColorSuccess,
                opacity: 1,
                border: 'none',
            },
            // hover
            '&:hover': {
                'color': colors.backgroundColorWhite,
                '& + $track': {
                    backgroundColor: colors.backgroundColorHover,
                    opacity: 1,
                    border: 'none',
                },
            },
            // disabled
            '&$disabled': {
                'color': colors.backgroundColorWhite,
                '& + $track': {
                    backgroundColor: colors.backgroundColorDisabledDark,
                    opacity: 1,
                    border: 'none',
                },
            },
        },
        '&$focusVisible $thumb': {
            color: colors.backgroundColorSuccess,
            border: `2px solid ${colors.backgroundColorWhite}`,
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: 'none',
        backgroundColor: colors.backgroundColorDisabled,
        opacity: 1,
    },
    checked: {},
    disabled: {},
    focusVisible: {},
});

export default SwitchStyles;
